export const individualClientType = 'Individual';
export const businessOwnerClientType = 'Business Owner';
export const businessOwnerPageOnly = 'Business Entities';
export const pageSteps = ['Personal Details', 'Family Members', 'Business Entities', 'Personal Interests', 'Review'];

export const ctxTermsAccepted = 'termsAccepted';
export const ctxClientTypeSelected = 'clientTypeSelected';
export const ctxClientBasicInfoCompleted = 'clientBasicInfoCompleted';
export const ctxClientProfileReviewed = 'clientProfileReviewed';
